import React, { useState, useEffect, useContext } from "react";
import MassCopy from "./MassCopy";
import GlobalsContext from "../../../context/GlobalsContext";
import { TeasersCountService, TeasersCopyService } from "../../../utils/api";

const MassCopyComponent = ({
  ids,
  globalCheck,
  search,
  onConfirm,
  ...props
}) => {
  const [loading, setLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [count, setCount] = useState("-");
  const [errors, setErrors] = useState({});

  const globalsContext = useContext(GlobalsContext);

  const params = {
    ids,
    search,
    globalCheck
  };

  useEffect(() => {
    TeasersCountService(params)
      .then(data => {
        setLoading(false);
        setCount(data.count);
      })
      .catch(e => {
        console.log(e);
      });
  }, []);

  const handleConfirm = (fields, options) => {
    setConfirmLoading(true);

    const data = { fields, ...params };

    TeasersCopyService(data)
      .then(() => {
        onConfirm(options);
      })
      .catch(resp => {
        setConfirmLoading(false);
        setErrors(resp.response.data.errors);
      });
  };

  return (
    <MassCopy
      {...props}
      loading={loading}
      confirmLoading={confirmLoading}
      categories={globalsContext.categories}
      count={count}
      onConfirm={handleConfirm}
      errors={errors}
    />
  );
};

export default MassCopyComponent;
